import {
  Button,
  DialogTrigger,
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogBody,
  MessageBar,
  Badge,
  DataGrid,
  DataGridHeader,
  DataGridRow,
  DataGridHeaderCell,
  DataGridBody,
  DataGridCell,
  MessageBarBody,
} from "@fluentui/react-components";
import {
  CheckmarkRegular,
  DismissRegular,
  MailErrorRegular,
  MailRegular,
} from "@fluentui/react-icons";
import { ITeamRequest } from "../../../Models/ITeamRequest";
import i18n from "i18next";
import { useState } from "react";
import { MyInvitesColumns } from "./MyInvitesColumns";

interface IDialogMyInvites {
  myInvites: ITeamRequest[];
  onDecline(item: ITeamRequest): void;
  onAccept(item: ITeamRequest): void;
  handleResponseError: string;
}

function DialogMyInvites(props: IDialogMyInvites) {
  const inviteColumns = MyInvitesColumns({
    onAccept: (item: ITeamRequest) => {
      props.onAccept(item);
    },
    onDecline: (item: ITeamRequest) => {
      props.onAccept(item);
    },
  });
  const [errorMessageLine, setErrorMessageLine] = useState<number>();
  return (
    <Dialog>
      <DialogTrigger action="open">
        <Button
          appearance="subtle"
          icon={
            props.myInvites.length > 0 ? (
              <MailRegular color="#ff6600" />
            ) : (
              <MailRegular />
            )
          }
          style={{ color: props.myInvites.length > 0 ? "#ff6600" : "" }}
        >
          {i18n.t<string>("invites")}
          {props.myInvites.length != 0 && (
            <Badge
              appearance="filled"
              style={{ background: "#ff6600", marginLeft: "3px" }}
            >
              {props.myInvites.length}
            </Badge>
          )}
        </Button>
      </DialogTrigger>
      <DialogSurface>
        <DialogTitle
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div>{i18n.t<string>("invites")}</div>
            {props.myInvites.length != 0 && (
              <Badge
                appearance="filled"
                style={{
                  background: "#ff6600",
                  marginLeft: "7px",
                  width: "26px",
                  height: "25px",
                  fontSize: "16px",
                }}
              >
                {props.myInvites.length}
              </Badge>
            )}
          </div>
          <DialogTrigger action="close">
            <Button appearance="transparent" icon={<DismissRegular />} />
          </DialogTrigger>
        </DialogTitle>
        <DialogBody style={{ display: "flex", flexDirection: "column" }}>
          {props.handleResponseError && (
            <MessageBar intent="error">
              <MessageBarBody>{props.handleResponseError}</MessageBarBody>
            </MessageBar>
          )}
          {props.myInvites.length == 0 && (
            <div>{i18n.t<string>("noItemsFound")}</div>
          )}
          {props.myInvites.length > 0 && (
            <div style={{ width: "100%" }}>
              <DataGrid
                sortable
                items={props.myInvites}
                columns={inviteColumns}
                resizableColumns
                columnSizingOptions={{
                  teamname: {
                    defaultWidth: 150,
                    minWidth: 150,
                    idealWidth: 150,
                  },
                  inviter: {
                    defaultWidth: 150,
                    minWidth: 150,
                    idealWidth: 150,
                  },
                  actions: {
                    defaultWidth: 250,
                    minWidth: 250,
                    idealWidth: 250,
                  },
                }}
              >
                <DataGridHeader>
                  <DataGridRow>
                    {({ renderHeaderCell }) => (
                      <DataGridHeaderCell>
                        {renderHeaderCell()}
                      </DataGridHeaderCell>
                    )}
                  </DataGridRow>
                </DataGridHeader>
                <DataGridBody<ITeamRequest>>
                  {({ item, rowId }) => (
                    <DataGridRow<ITeamRequest> key={rowId}>
                      {({ renderCell }) => (
                        <DataGridCell>{renderCell(item)}</DataGridCell>
                      )}
                    </DataGridRow>
                  )}
                </DataGridBody>
              </DataGrid>
            </div>
          )}
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
export default DialogMyInvites;
